import gql from 'graphql-tag';

const refundCreditsMutation = gql`
mutation refundCredits(
  $organisationId: String!,
  $owner: String!,
  $amount: Int!,
  $consumeBy: String!,
  $reason: String,
  $notes: String
  ) {
    refundCredits(organisationId: $organisationId, owner: $owner, amount: $amount, consumeBy: $consumeBy, reason: $reason, notes: $notes)
}
`;

const refundCredits = (organisationId) => ({
  mutation: refundCreditsMutation,
  module: 'organisations',
  buildVariables: ({
    owner,
    amount,
    consumeBy,
    reason,
    notes







  }) => ({
    organisationId,
    owner,
    amount,
    consumeBy,
    reason,
    notes
  })
});

export default refundCredits;